import React, { useEffect, useState } from "react";
import { SelectUi } from "../../../ui/SelectUi";
import { get_tipo_tenido_tela } from "../../../../actions/produccion";

export const TipoTenidoTelaSelect = ({ ...restProps }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const OnLoad = async () => {
      const data = await get_tipo_tenido_tela();
      setItems(data);
    };
    OnLoad();
    return () => {
      setItems([]);
    };
  }, []);

  return <SelectUi data={items} {...restProps} />;
};
